module.exports = __webpack_public_path__ + "2b4c6a36f77cfe186b5864e543f4639d.fbx";